import { useState, useRef, useEffect } from "react";
import Hero from "./Hero/Hero";
import About from "./About/About";
import Market from "./Market/Market";
import Services from "./Services/Services";
import Brands from "./Brands/Brands";
import Projects from "./Projects/Projects";
import Academy from "./Academy/Academy";
import Statistics from "./Statistics/Statistics";
import Map from "./Map/Map";
import MarketMobile from "./Market/MarketMobile";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch";

const Home = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();
  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("home");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data?.hero} />
        <About data={data?.about} />
        <Market data={data?.segments} />
        <MarketMobile data={data?.segments} />
        <Brands data={data?.brands} />
        <Services data={data?.services} />
        <Academy data={data?.news} />
        <Projects data={data?.projects} />
        <Statistics data={data?.statistics} />
        <Map />
      </main>
    );
  }
};

export default Home;
